import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    navigateIn(){
        [...this.$( 'menu' )[0].querySelectorAll('a')].forEach(a => {
            a.parentNode.classList.toggle( 'is-active', a.href === location.href );
        } );
    }

    navigateOut(){

    }

    destroy(){}

}
